import { IProjectElementDetailsOutput } from './ProjectElementsModel';

export interface ITransmittalSerialNoInputModel {
  projectId: number
  groupId: number | undefined
  moduleId: number
  elementDetails: ITransmittalElementSLNoInputModel[] |(ITransmittalElementSLNoInputModel | undefined)[]
}

export interface ITransmittalElementSLNoInputModel {
  deId: number
  deDescription: string
  dedId: number
  dedDescription: string
  dedShortDescription: string
  sortBy: number
}

export interface ITransmittalMsgInputModel {
  inputType: string,
  project_Id: number | undefined,
  message_Id?: number | undefined,
  parent_Message_Id?: number | undefined,
  message_Type: number | undefined,
  message_Subject: string,
  message_Body: string,
  message_Number: string | null,
  message_Serial_Number: number | null,
  message_Category: number,
  response_Type?: number,
  respond_On?: string|null,
  issue_Reason?: number,
  discipline?: number,
  cust_Ref_No?: string,
  has_Attachments: boolean,
  is_Confidential: boolean,
  is_Mail_Sent: boolean,
  sent_On: Date | null,
  is_Active: boolean,
  userId: number | undefined,
  message_Note? : string |null
}

export interface ITransmittalMsgReceiverInput {
  message_Id: number;
  transmittalFromDetails: IReceiverInput[];
  transmittalToDetails: IReceiverInput[];
  transmittalCcDetails: IReceiverInput[];
  is_Active: boolean;
  userId: number | undefined;
}

export interface IReceiverInput {
  member_Id: number;
  receiver_Type: number;
  receiver_Group?: number|null|undefined;
  sort_By?: number;
  member_Name?: string;
}

export interface ITransmittalGroupMemberInput {
  message_Id: number,
  distributionMemberDetails: IDistributionMemberDetails[],
  is_Active: true,
  userId: number | undefined
}

export interface IDistributionMemberDetails {
  group_Member: string,
  group_Id: number,
  quantity: number,
  category: string,
  copy_Type: string,
  address?: string|null,
  remarks?: string

}

export interface ITransmittalMsgDocumentInput {
  message_Id: number,
  transmittalDocumentMessageDetails: ITransmittalDocumentMsgDetails[],
  is_Active: boolean,
  userId: number | undefined
}

export interface ITransmittalDocumentMsgDetails {
  doc_Id: number,
  revision_No: string,
  response?: number,
  response_Remarks: string
}

export interface ITransmittalDocumentInput {
  message_Id: number,
  transmittalDocumentDetails: ITransmittalDocumentDetails[],
  is_Active: boolean,
  userId: number | undefined
}

export interface ITransmittalDocumentDetails {
  doc_Id: number,
  revision_No: string,
  quantity?: number,
  category?: number,
  doc_Type?: number,
  remarks: string
}

export interface ITransmittalDocumentCopyInput {
  message_Id: number,
  transmittalDocumentCopyDetails: ITransmittalDocumentCopyDetails[],
  is_Active: boolean,
  userId: number,
  dedId: number
}

export interface ITransmittalDocumentCopyDetails {
  doc_Id: number,
  revision_No: string,
  copy_Type?: number,
  no_of_Copies?: number
}

export interface ITransmittalDocumentElementInput {
  elementDetailsMapping: ITransmittalDocumentElementDetails[],
}

export interface ITransmittalDocumentElementDetails {
  userId: number | undefined,
  messageId: number,
  deId: number,
  dedId: number,
  isActive: boolean
}

export interface ITransmittalDocViewModel {
  doc_Id: number;
  revision_No: string;
  title: string;
  document_No: string;
  authorized_By: string;
  quantity?: number;
  category?: IProjectElementDetailsOutput;
  type?: IProjectElementDetailsOutput[];
  remarks: string;
  isAttachemtUploded?: boolean;
  selectedType?: number[];
  selectedCategory?: number;
  scheduleType?: number;
  workflowId?: number;
  task_Id?:string;
}

export interface ITransmittalViewDocDetails {
  authorised_By: string;
  category_Description?: string;
  category_Short_Description?: string;
  created_By?: string;
  doc_Id: number;
  doc_No: string;
  doc_Title: string;
  quantity: number
  remarks: string;
  revision_No: string;
  type?: IProjectElementDetailsOutput[];
  type_Description?: string;
  type_Short_Description?: string;
  scheduleType?:number;
  task_Id?:string
}

export interface ITransmittalMailDetails {
  from_List: string,
  to_List: string,
  cc_List: string,
  project_Code: string,
  discipline: string,
  mail_Subject: string,
  mail_Body: string,
  message_Id: number
}

export interface ITransmittalMasterInput {
  project_id: number | null;
  message_Id?: number;
}

export interface ITransmittalDetailsModel {
  category_Description?: any;
  created_On: Date;
  cust_Ref_No?: any;
  discipline: number;
  discipline_Description?: any;
  has_Attachments: boolean;
  is_Confidential: boolean;
  is_Mail_Sent: boolean;
  message_Id: number;
  message_Number: string;
  message_Serial_Number: number;
  message_Subject: string;
  message_Type: number;
  project_Id: number;
  respond_On?: Date;
  response_Type?: number;
  isSelected?: boolean;
  documentNo?: string;
  message_Note? : string;
  isDtnReleased?: boolean; 
}

export interface ITransmittalDocumentAttachmentModel {
  docId: number
  revisionNo: string,
  fileName: string,
  fileExtension: string,
  fileSize: number
}

export interface ITransmittalSignedDocumentsModel {
  msgId: number | undefined,
  projectId: number | undefined,
  signedDocuments: ITransmittalDocumentAttachmentModel[],
  createdBy: number | undefined
}
